import React, { Component } from "react";
// Components
import { Button } from "@components/Input";
// Infrastructure
import { getRoleName, returnElementFromArray } from "vendor/application";
// Translations
import { withTranslation } from "react-i18next";
import { Box, Grid, Tooltip } from "@material-ui/core";

class CardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: this.props.list
    };
  }

  handleHeader = (layout) => {
    const { t } = this.props;
    if (layout === "users") {
      return (
        <tr>
          <th>{t("users.table.name")}</th>
          <th>{t("users.table.role")}</th>
          <th>{t("users.table.project")}</th>
        </tr>
      );
    }
  };

  getClass = (role) => {
    const { user } = this.props.data;
    if (user.role_name === "Supervisor") {
      switch (role) {
        case "Supervisor":
        case "Agent":
          return "";
        default:
          return "no_access";
      }
    } else if (user.role_name === "Administrator") {
      switch (role) {
        case "SuperAdministrator":
          return "no_access";
        default:
          return "";
      }
    }
    return "";
  };

  handleContent = (layout) => {
    const { projects } = this.props.data;
    const { list } = this.state;
    if (layout === "users") {
      return list.map((el, i) => {
        var role_name = getRoleName(el.roles[0]),
          projects_user = this.getProjectsName(el.projects);
        return (
          <tr
            key={i}
            className={this.getClass(role_name)}
            onClick={(e) => {
              this.editElement(e, el.id, role_name);
            }}
          >
            <td>{el.first_name}</td>
            <td>{this.props.t(`users.roles.${role_name.toLowerCase()}`)}</td>
            <td className={"elements__chips"}>
              <div>
                {role_name === "SuperAdministrator"
                  ? projects.active.map((project, project_i) => {
                      return (
                        <span className="projects-rounded" key={project_i}>
                          {project.name}
                        </span>
                      );
                    })
                  : projects_user.map((project, project_i) => {
                      return (
                        <span className="projects-rounded" key={project_i}>
                          {project.name}
                        </span>
                      );
                    })}
              </div>
            </td>
          </tr>
        );
      });
    }
  };

  getProjectsName = (array) => {
    var projects = this.props.data.projects.active;
    var data = [];
    array.forEach((el) => {
      var res = returnElementFromArray(el, projects, "id");
      if (res) {
        data.push(res);
      }
    });
    return data;
  };

  editElement = (e, id, role) => {
    e.preventDefault();

    if (!this.getClass(role)) {
      const { history } = this.props;
      history.push(`${history.location.pathname}/edit/${id}`);
    }
  };

  render() {
    const { t, handleClickOpen, data, history } = this.props;
    const { user, plan } = data;
    const isAdminAndCentrideskFalse =
      user.role_name === "Administrator" && !plan.platform.centridesk;
    const location = history.location.pathname === "/users";
    return (
      <React.Fragment>
         <div
          className={
           location
              ? " card-special"
              : ""
          }
        >       
          <div className="card">
            <div className="header-container">
              <div className="info">
                <React.Fragment>
                  <div className="info-tooltip">
                    <span className="title">{t("users.header_title")}</span>
                  </div>
                  <span>{t("users.header_description")}</span>
                </React.Fragment>
              </div>
              {isAdminAndCentrideskFalse ? (
                <div className="actions actions-search">
                  <Box>
                    <Grid container justifyContent="center">
                      <Grid item>
                        <Tooltip
                          title={t("users.tooltip_user_admin")}
                          placement="left"
                          arrow
                        >
                          <span>
                            <Button
                              id={"new_btn_users"}
                              text={t("users.button_create")}
                              disabled={isAdminAndCentrideskFalse}
                            />
                          </span>
                        </Tooltip>
                        <style jsx>{`
                          .MuiTooltip-tooltip {
                            font-size: 11px;
                            text-align: center;
                            width: 100%;
                          }
                          .MuiTooltip-tooltipPlacementLeft {
                            max-width: 240px;
                          }
                        `}</style>
                      </Grid>
                    </Grid>
                  </Box>
                </div>
              ) : (
                <div className="actions actions-search">
                  <Button
                    id={"new_btn_users"}
                    type={"primary"}
                    onClick={() => handleClickOpen()}
                    text={t("users.button_create")}
                  />
                </div>
              )}
            </div>
            <div className="content scroll_table">
              {
                <React.Fragment>
                  <table className={"table-users"}>
                    <thead>{this.handleHeader("users")}</thead>
                    <tbody>{this.handleContent("users")}</tbody>
                  </table>
                </React.Fragment>
              }
            </div>
            </div>
          </div>
      </React.Fragment>
    );
  }
}

export default withTranslation("users")(CardList);
